export default __webpack_public_path__ + "static/media/share.096ed9d0.svg";